import { Message } from 'element-ui'
import * as session from './session'

export class OperationError extends Error {
  constructor (message = '失败！') {
    super(message)
    this.name = 'OperationError'
  }
}

export let ERROR_MESSAGE = {
  UNKNOWN: '未知错误',
  NETWORK: '网络异常，请检查联网状态',
  SERVER: '系统异常，请重试',
  NETWORK_OR_SERVER: '网络或系统异常，请重试',
}

export let CODE_MESSAGE = {
  2: {
    'Inactivated!': '账户未激活',
    'Auth Failed!': '授权失败',
    'PassportDoesNotExist': undefined,
  },
}

// 显示给用户的错误信息
export function getErrorMessage (e) {
  if (!e) return ERROR_MESSAGE.UNKNOWN
  // http 请求错误
  if (e.response) {
    // 超时
    if (e.response.status === 504) return ERROR_MESSAGE.NETWORK_OR_SERVER
    // server 端出了问题
    if (e.response.status >= 500) return ERROR_MESSAGE.SERVER
    return e.response.status + ' ' + e.response.statusText
  }
  if (e.request) return ERROR_MESSAGE.NETWORK
  // 不同的 code 需要给出不同的 message
  if (e.code && e.message) {
    let map = CODE_MESSAGE[e.code] || {}
    return map.hasOwnProperty(e.message) ? map[e.message] : ERROR_MESSAGE.UNKNOWN
  }
  // 没有 message 就只能给出未知错误了
  if (!e.message) return ERROR_MESSAGE.UNKNOWN
  // 操作失败
  if (e.name === 'OperationError') return e.message
  if (e.stack) console.error(e.stack)
  // 其他情况不让用户看到错误信息
}

export function handleError (e, logout = true) {
  let message = getErrorMessage(e)
  if (message) Message.error(message)
  if (logout && e && e.code === 2) session.logout()
}



// WEBPACK FOOTER //
// ./src/common/error.js